import { Endpoints } from "../../../constants/endpoints";
import { TUserRaw } from "./types";
import client from "../../client";

export const getUser = async () => {
  const { data } = await client.get<TUserRaw>(Endpoints.getUser);
  return data.user;
};
